import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityTimeline = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'goal_update': return 'Target';
      case 'behavioral_incident': return 'AlertTriangle';
      case 'document_upload': return 'FileText';
      case 'profile_update': return 'User';
      case 'meeting': return 'Calendar';
      case 'assessment': return 'ClipboardCheck';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'goal_update': return 'text-primary';
      case 'behavioral_incident': return 'text-warning';
      case 'document_upload': return 'text-secondary';
      case 'profile_update': return 'text-accent';
      case 'meeting': return 'text-success';
      case 'assessment': return 'text-primary';
      default: return 'text-muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInMinutes < 1440) {
      return `${Math.floor(diffInMinutes / 60)}h ago`;
    } else {
      return `${Math.floor(diffInMinutes / 1440)}d ago`;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-card-foreground">Recent Activity</h3>
        <Icon name="Activity" size={16} className="text-muted-foreground" />
      </div>
      <div className="space-y-4 max-h-80 overflow-y-auto">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Clock" size={32} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          activities?.map((activity, index) => (
            <div key={activity?.id} className="flex gap-3">
              {/* Timeline Line */}
              <div className="flex flex-col items-center">
                <div className={`p-1.5 rounded-full bg-muted border-2 border-surface`}>
                  <Icon 
                    name={getActivityIcon(activity?.type)} 
                    size={12} 
                    className={getActivityColor(activity?.type)} 
                  />
                </div>
                {index < activities?.length - 1 && (
                  <div className="w-px h-8 bg-border mt-2" />
                )}
              </div>
              
              {/* Activity Content */}
              <div className="flex-1 min-w-0 pb-4">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground line-clamp-2">
                      {activity?.title}
                    </p>
                    {activity?.description && (
                      <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                        {activity?.description}
                      </p>
                    )}
                    <div className="flex items-center gap-2 mt-2">
                      <span className="text-xs text-muted-foreground">
                        {formatTimeAgo(activity?.timestamp)}
                      </span>
                      {activity?.user && (
                        <>
                          <span className="text-xs text-muted-foreground">•</span>
                          <span className="text-xs text-muted-foreground">
                            by {activity?.user}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  
                  {activity?.priority === 'high' && (
                    <div className="flex-shrink-0">
                      <div className="w-2 h-2 bg-destructive rounded-full" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {activities?.length > 0 && (
        <div className="pt-3 border-t border-border">
          <button className="text-xs text-primary hover:text-primary/80 transition-colors duration-200">
            View all activity →
          </button>
        </div>
      )}
    </div>
  );
};

export default RecentActivityTimeline;